import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">读者热议</h2>
          <p className="text-sm text-foreground-500">吃瓜群众犀利点评，来看看大家都在讨论什么</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="flex gap-4 p-5 bg-background-100 rounded-xl"
            >
              <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={comment.avatar}
                  alt={comment.nickname}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1.5">
                  <span className="text-sm font-medium text-foreground-900">{comment.nickname}</span>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                  {comment.content}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-heart-line text-primary-400"></i>
                  <span>{comment.likes.toLocaleString()}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}